import type { SxProps } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import { DateChip } from '../../chips/DateChip';
import { GroupChatChip } from '../../chips/GroupChatChip';

export interface ChatInfoProps {
  sentAt?: Date;
  text?: string;
  lang?: string;
  groupChatText?: string;
  sx?: SxProps;
}

const InfoText = styled(Typography)(({ theme }) => {
  const palette = (theme.vars || theme).palette;
  return { maxWidth: 480, textAlign: 'center', color: palette.text.secondary };
});

export const ChatInfo = ({
  sentAt,
  text,
  lang = 'en',
  groupChatText,
}: ChatInfoProps) => {
  return (
    <Stack sx={{ gap: 1, alignItems: 'center' }}>
      {(sentAt || groupChatText) && (
        <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
          {sentAt && <DateChip date={sentAt} lang={lang} />}
          {groupChatText && <GroupChatChip label={groupChatText} />}
        </Stack>
      )}
      {text && <InfoText variant="body2">{text}</InfoText>}
    </Stack>
  );
};
